/**
 * relay-42 Phase 2b (DEC-26) — per-project sidebar visibility.
 *
 * Source of truth lives at `relay_workspaces/{workspaceId}.hidden_projects`,
 * an array of project names that should be excluded from the sidebar
 * Pinned and Recent zones. The Settings → Projects modal toggles
 * membership in this array; everything else is a view-layer filter.
 *
 * Pure module: predicate + array transform. Firestore writes happen
 * in App.tsx where the `db` handle and `setDoc` import already live —
 * keeps this file unit-testable without mocking the SDK.
 */

export function isProjectHidden(hiddenProjects: string[], name: string): boolean {
  return hiddenProjects.includes(name);
}

export function toggleProjectHidden(hiddenProjects: string[], name: string): string[] {
  return hiddenProjects.includes(name)
    ? hiddenProjects.filter(n => n !== name)
    : [...hiddenProjects, name];
}

export function filterVisibleNames<T extends { name: string }>(
  items: T[],
  hiddenProjects: string[],
): T[] {
  if (hiddenProjects.length === 0) return items;
  const hidden = new Set(hiddenProjects);
  return items.filter(p => !hidden.has(p.name));
}

export function filterVisibleTags(tags: string[], hiddenProjects: string[]): string[] {
  if (hiddenProjects.length === 0) return tags;
  const hidden = new Set(hiddenProjects);
  return tags.filter(t => !hidden.has(t));
}
